<template>
  <v-modal
    handle-click-bg
    :min-width="screen.breakPoint.tabPort ? '50rem' : null"
    :full="!screen.breakPoint.tabPort" animation="slide-up"
    :max-height="!screen.breakPoint.tabPort ? '90vh' : null"
    :position="!screen.breakPoint.tabPort ? 'bottom' : null"
    v-model="showModal"
  >
    <template v-slot:activator="{ on }">
      <div class="fill-by-egrul">
        <v-input
          :placeholder="placeholder"
          :label="label"
          :typeName="typeName"
          :disabled="disabled"
          :error="error"
          v-model="model"
          style="width: 100%;"
          class="mr-1"
        ></v-input>
        <div class="d-flex mt-1 mb-1">
          <action-link v-if="screen.breakPoint.tabPort" size="small" @click="disabled ? () => {} : on()" class="ml-auto">{{ $t('components.Profile.fillByEgrul.fillRequisitesByInn') }}</action-link>
          <v-button :disabled="disabled" @click="on" size="small" width="full" v-else>{{ $t('components.Profile.fillByEgrul.fillRequisitesByInn') }}</v-button>
        </div>
      </div>
    </template>

    <template v-slot:header>{{ $t('components.Profile.fillByEgrul.fillRequisitesByInn') }}</template>

    <div class="fill-by-egrul-content">
      <div class="d-flex justify-strech">
        <v-input
          v-model="model"
          :placeholder="$t('components.Profile.fillByEgrul.inn')"
          style="width: 100%;"
        ></v-input>
        <v-button class="ml-05" @click="getReqs()" :loading="loading">{{ $t('components.Profile.fillByEgrul.find') }}</v-button>
      </div>

      <div class="fill-by-egrul-content__error text-color-error" v-if="reqError">{{reqError}}</div>

      <div class="fill-by-egrul-content__reqs mt-2" v-if="requisites">
        <div class="fill-by-egrul-content__req-item d-flex" v-if="requisites.email">
          <div style="width: 40%" class="text--medium">{{ $t('components.Profile.fillByEgrul.email') }}</div>
          <div style="width: 50%">{{ requisites.email }}</div>
        </div>

        <div class="fill-by-egrul-content__req-item d-flex" v-if="requisites.reqCompanyDirector">
          <div style="width: 40%" class="text--medium">{{ $t('components.Profile.fillByEgrul.registrationDate') }}</div>
          <div style="width: 50%">{{ requisites.reqCompanyRegistrationDate }}</div>
        </div>
        <div class="fill-by-egrul-content__req-item d-flex" v-if="requisites.reqContactPhone">
          <div style="width: 40%" class="text--medium">{{ $t('components.Profile.fillByEgrul.contactPhone') }}</div>
          <div style="width: 50%">{{ requisites.reqContactPhone }}</div>
        </div>
        <div class="fill-by-egrul-content__req-item d-flex" v-if="requisites.reqInn">
          <div style="width: 40%" class="text--medium">{{ $t('components.Profile.fillByEgrul.inn') }}</div>
          <div style="width: 50%">{{ requisites.reqInn }}</div>
        </div>
        <div class="fill-by-egrul-content__req-item d-flex" v-if="requisites.reqKpp">
          <div style="width: 40%" class="text--medium">{{ $t('components.Profile.fillByEgrul.kpp') }}</div>
          <div style="width: 50%">{{ requisites.reqKpp }}</div>
        </div>
        <div class="fill-by-egrul-content__req-item d-flex" v-if="requisites.reqLegalAddress">
          <div style="width: 40%" class="text--medium">{{ $t('components.Profile.fillByEgrul.regAddress') }}</div>
          <div style="width: 50%">{{ requisites.reqLegalAddress }}</div>
        </div>
        <div class="fill-by-egrul-content__req-item d-flex" v-if="requisites.reqLegalName">
          <div style="width: 40%" class="text--medium">{{ $t('components.Profile.fillByEgrul.companyName') }}</div>
          <div style="width: 50%">{{ requisites.reqLegalName }}</div>
        </div>
        <div class="fill-by-egrul-content__req-item d-flex" v-if="requisites.reqOgrn">
          <div style="width: 40%" class="text--medium">{{ $t('components.Profile.fillByEgrul.ogrn') }}</div>
          <div style="width: 50%">{{ requisites.reqOgrn }}</div>
        </div>
        <div class="fill-by-egrul-content__req-item d-flex" v-if="requisites.reqOkved">
          <div style="width: 40%" class="text--medium">{{ $t('components.Profile.formFields.OKVED') }}</div>
          <div style="width: 50%">{{ requisites.reqOkved }}</div>
        </div>

        <v-button size="full" v-if="requisites" class="mt-2" color="success" @click="fill()">{{ $t('components.Profile.fillByEgrul.fill') }}</v-button>
      </div>
    </div>
  </v-modal>
</template>

<script>
import vButton from '@/ui/controls/vButton'
import ActionLink from '@/ui/controls/ActionLink'
import vInput from '@/ui/controls/vInput'
import vModal from '@/ui/modals/vModal'

import { EgrulDataGQL } from '@/graphql/queries'

import screen from '@/mixins/screen'

export default {
  data () {
    return {
      headerHeight: 70,
      loading: false,
      reqError: null,
      searchQuery: null,
      requisites: null,
      showModal: false
    }
  },

  props: {
    value: {
      type: [String],
      default: null
    },

    placeholder: {
      type: String,
      default: null
    },

    label: {
      type: String,
      default: null
    },

    typeName: {
      type: String,
      default: null
    },

    disabled: {
      type: Boolean,
      default: false
    },

    error: {
      type: String,
      default: null
    }
  },

  mixins: [screen],

  components: {
    vButton,
    vInput,
    vModal,
    ActionLink
  },

  computed: {
    model: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  },

  methods: {
    computeHeights () {
      const header = document.querySelector('.modal-header-input')
      if (header) {
        this.headerHeight = header.clientHeight
      }
    },

    async getReqs () {
      this.loading = true
      try {
        const { data } = await this.$apollo.query({
          query: EgrulDataGQL,
          variables: {
            inn: this.value
          }
        })

        this.requisites = data.commonData.EgrulData
        this.loading = false
      } catch (e) {
        this.reqError = 'Реквизиты не найдены'
        this.loading = false
      }
    },

    fill () {
      this.$emit('fill', this.requisites)
      this.showModal = false
    }
  },

  watch: {
    value () {
      this.reqError = null
    }
  }
}
</script>

<style lang="scss">
.fill-by-egrul-content {
  &__req-item {
    padding-top: 1rem;
    padding-bottom: 1rem;
    &:not(:last-child) {
      border-bottom: 1px solid $color-azure-light;
    }
  }
}
</style>
